export const PRESET_SIZES = {
	sm: { w: 40, h: 40 },
	md: { w: 60, h: 60 },
	lg: { w: 80, h: 80 },
} as const;

export const EXTENSION = 'png';

export const CONTENTS = [
	'hamburger',
	'cheeseburger',
	'baconizer',
	'fries',
	'sandwich',
	'hotdog',
	'rod1',
	'rod2',
	'rod3',
	'rod4',
	'worm',
	'bread',
	'maggots',
	'corn',
	'wood',
	'test',
	'backpack',
	'engine',
	'axe',
	'shovel',
	'pickaxe',
	'canister_1',
	'canister_2',
	'canister_3',
	'cigarettes',
	'fastering',
	'med_1',
	'med_2',
	'med_3',
	'radio',
	'simcard',
	'vehicle_diagnostic',
	'batteries',
	'cardboard',
	'copper_wire',
	'electronic_wires',
	'electronic_chip',
	'glass_bottle',
	'plastic_bottle',
	'old_books',
	'rags',
	'scrap_metal',
	'boilies',
	'dough',
	'flies',
	'shrimps',
	'beer',
	'coffee',
	'cola',
	'donut',
	'fortune_cookie',
	'juice',
	'orange',
	'pizza',
	'ribs',
	'sushi',
	'water',
	'amur_white',
	'amur_black',
	'buffalo_bigmouth',
	'carp_mirror',
	'smelt',
	'rudd',
	'kutum',
	'bream',
	'salmon_atlantic',
	'perch',
	'sturgeon_persian',
	'shad_caspian',
	'catfish',
	'sturgeon_sterlet',
	'pikeperch',
	'roach',
	'silver_carp_bighead',
	'eel',
	'trout_lake',
	'sabrefish',
	'pike_common',
	'potato',
	'carrot',
	'cabbage',
	'potato_seeds',
	'carrot_seeds',
	'cabbage_seeds',
	'oak_wood',
	'pine_wood',
	'birch_wood',
	'metal_ore',
	'copper_ore',
	'gold_ore',
	'crab',
	'crab_king',
	'crayfish',
	'lobster',
	'lobster_blue',
	'lobster_spiny',
	'crab_trap',
] as const;
